// +----------------------------------------------------------------------
// | CRMEB [ CRMEB 赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB 并不是自由软件，未经许可不能去掉 CRMEB 相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var kingdeeVerificationLogRouter = {
  path: '/kingdeeVerificationLog',
  component: Layout,
  redirect: '/kingdeeVerificationLog/list',
  name: 'KingdeeVerificationLog',
  meta: {
    title: '金蝶核销订单差异日志',
    icon: 'el-icon-s-finance',
    noCache: true,
    alwaysShow: true
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/kingdeeVerificationLog/index');
    },
    name: 'KingdeeVerificationLogList',
    meta: {
      title: '金蝶核销订单差异日志',
      noCache: true,
      affix: false,
      icon: 'el-icon-s-finance',
      perms: 'api:admin:kingdee:verification:log:list',
      activeMenu: '/kingdeeVerificationLog'
    }
  }],
  // 确保这是一个顶级菜单，不属于任何其他菜单
  pid: 0
};
export default kingdeeVerificationLogRouter;